import {handleSpaceKeyDown} from '@wix/panda-js-utils'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import c from '../../classnames.scss'
import {Error} from '../../form/commons/error'
import {PolicyCheckboxProps} from './interfaces'
import s from './policy-checkbox.scss'
import {PolicyList} from './policy-list'

export const PolicyCheckbox = ({
  onChange,
  value,
  label,
  checked,
  policies,
  onPolicyClick,
  errorShown,
}: PolicyCheckboxProps) => {
  const getPolicyAriaLabel = () => `${label} ${policies.map(({name}) => name).join(', ')}`

  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const disabledButtonViewerEnabled = experiments.enabled(ExperimentNames.DisabledButtonsViewer)

  return (
    <div className={s.policyCheckboxContainer}>
      <div className={classNames(s.labelContainer, s.wrapper)} data-hook={DH.FORM_INVALID_FIELD}>
        <div className={s.checkboxWrapper}>
          <span
            tabIndex={0}
            role="checkbox"
            aria-checked={checked}
            onClick={() => onChange(value)}
            onKeyDown={handleSpaceKeyDown(onChange)}
            aria-label={getPolicyAriaLabel()}
          >
            <input
              className={s.input}
              data-hook={DH.CHECKBOX_INPUT}
              type="checkbox"
              value={value}
              checked={checked}
              onChange={() => onChange(value)}
            />
            <label className={s.wrapper}>
              <span
                className={classNames(c.formBorderColor, s.checkbox, {[s.checkedCheckbox]: checked})}
                data-hook={DH.CHECKBOX}
              />
            </label>
          </span>
        </div>
        <div>
          <span
            className={classNames(c.formLabelsFont, c.formLabelsColor, s.checkboxLabel)}
            data-hook={DH.CHECKBOX_LABEL}
          >
            {label}
          </span>
          <span className={classNames(c.formLabelsFont, s.linkColor, s.checkboxLabel)}>
            <PolicyList policies={policies} onPolicyClick={onPolicyClick} />
          </span>
        </div>
      </div>
      {disabledButtonViewerEnabled && errorShown && (
        <Error dataHook="checkbox-error" error={t('formError.requiredError')} />
      )}
    </div>
  )
}
